import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAdminUser, IOrganization } from "../types/AdminTypes";

interface IAdminState {
  users: IAdminUser[];
  organizations: IOrganization[];
  isLoading: Boolean;
  error: string | null;
}

const initialState: IAdminState = {
  users: [],
  organizations: [],
  isLoading: false,
  error: null,
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    getAllUsersLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    getAllUsersSuccess(state, action: PayloadAction<IAdminUser[]>) {
      state.isLoading = false;
      state.error = "";
      state.users = action.payload;
    },

    getAllUsersFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    createUserLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    createUserSuccess(state, action: PayloadAction<IAdminUser>) {
      state.isLoading = false;
      state.error = "";
      state.users.push(action.payload);
    },

    createUserFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getAllOrganizationsLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    getAllOrganizationsSuccess(state, action: PayloadAction<IOrganization[]>) {
      state.isLoading = false;
      state.error = "";
      state.organizations = action.payload;
    },

    getAllOrganizationsFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    createOrganizationLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    createOrganizationSuccess(state, action: PayloadAction<IOrganization>) {
      state.isLoading = false;
      state.error = "";
      state.organizations.push(action.payload);
    },

    createOrganizationFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default adminSlice.reducer;
